import React, { useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { useAlert } from 'react-alert';
import { useApiContext } from "../../contexts/ApiContext";
 

function LicenseDetails(props) {
  const { setIsApiSuccess } = useApiContext();
    const alert = useAlert()
const [license,setLicense]=useState({})
const [checkIds,setCheckIds]=useState([])
const [refresh,setRefresh]=useState(false)

useEffect(() => {setLicense([]);setRefresh(!refresh)},[props.id])

    useEffect(() => {

        const tokenString = sessionStorage.getItem('usertoken');

        let str = tokenString.replace(/["]+/g, '')
       
        axios.get(`${APIURL}/api/v1/staff/hospital-licenses/?hospital_id=${props.id}&${TZ}`, {
            headers: {

                "Authorization": 'Token ' + str
            }
        })
            .then(res => {

                if (res.data.status === "success") {
                     setLicense(res.data.plan_details)
                }


            })
            .catch(err => {

            })
        

    }, [refresh]);
    const handleSave = (status) => {
      document.getElementById("approve-btn").disabled = true;
      document.getElementById("reject-btn").disabled = true;
        const id = props.id;
        const tokenString = sessionStorage.getItem("usertoken");
        let str = tokenString.replace(/["]+/g, "");
        const dataToUpdate={
                "hospital_id":id,
                "purchased_license_ids":checkIds,
                "status":status
        }
        axios
          .put(`${APIURL}/api/v1/staff/hospital-licenses/`, dataToUpdate, {
            headers: {
              Authorization: "Token " + str,
              "Content-Type": "application/json",
            },
          })
    
          .then((res) => {
            
            if (res.data.status === "success") {
              setIsApiSuccess(true);
              alert.success(res.data.message)
              setCheckIds([])
              setRefresh(!refresh)
             } else {
              alert.error(res.data.message);
            }
          })
          .catch((err) => {
            alert.error("error in submission")
          });
         
      };
  return (
    <div style={{minHeight:"71vh"}} >
     {license.plan_type ?<>
        {license.requested_licenses.length>0&&<>
        <div className="" style={{}}>
                <h6 className="row"><span className="col-3" ><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24"><mask id="lineMdCloudAltDownloadLoop0"><g fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path stroke-dasharray="64" stroke-dashoffset="64" d="M7 19h11c2.21 0 4 -1.79 4 -4c0 -2.21 -1.79 -4 -4 -4h-1v-1c0 -2.76 -2.24 -5 -5 -5c-2.42 0 -4.44 1.72 -4.9 4h-0.1c-2.76 0 -5 2.24 -5 5c0 2.76 2.24 5 5 5Z"><animate fill="freeze" attributeName="stroke-dashoffset" dur="0.6s" values="64;0"/><set fill="freeze" attributeName="opacity" begin="0.7s" to="0"/></path><g fill="#fff" stroke="none" opacity="0"><circle cx="12" cy="10" r="6"><animate attributeName="cx" begin="0.7s" dur="30s" repeatCount="indefinite" values="12;11;12;13;12"/></circle><rect width="9" height="8" x="8" y="12"/><rect width="15" height="12" x="1" y="8" rx="6"><animate attributeName="x" begin="0.7s" dur="21s" repeatCount="indefinite" values="1;0;1;2;1"/></rect><rect width="13" height="10" x="10" y="10" rx="5"><animate attributeName="x" begin="0.7s" dur="17s" repeatCount="indefinite" values="10;9;10;11;10"/></rect><set fill="freeze" attributeName="opacity" begin="0.7s" to="1"/></g><g fill="#000" fill-opacity="0" stroke="none"><circle cx="12" cy="10" r="4"><animate attributeName="cx" begin="0.7s" dur="30s" repeatCount="indefinite" values="12;11;12;13;12"/></circle><rect width="9" height="6" x="8" y="12"/><rect width="11" height="8" x="3" y="10" rx="4"><animate attributeName="x" begin="0.7s" dur="21s" repeatCount="indefinite" values="3;2;3;4;3"/></rect><rect width="9" height="6" x="12" y="12" rx="3"><animate attributeName="x" begin="0.7s" dur="17s" repeatCount="indefinite" values="12;11;12;13;12"/></rect><set fill="freeze" attributeName="fill-opacity" begin="0.7s" to="1"/></g><g fill="#fff" stroke="none"><path d="M10.5 10h3v0h-3z"><animate fill="freeze" attributeName="d" begin="0.7s" dur="0.2s" values="M10.5 10h3v0h-3z;M10.5 10h3v4h-3z"/></path><path d="M8 13h8l-4 0z"><animate fill="freeze" attributeName="d" begin="0.9s" dur="0.1s" values="M8 13h8l-4 0z;M8 13h8l-4 4z"/><animateMotion begin="1s" calcMode="linear" dur="1.5s" keyPoints="0;0.25;0.5;0.75;1" keyTimes="0;0.1;0.5;0.8;1" path="M0 0v1v-2z" repeatCount="indefinite"/></path></g></g></mask><rect width="32" height="32" fill="orange" mask="url(#lineMdCloudAltDownloadLoop0)"/></svg>
                &nbsp;<span ><b>New requests</b></span></span>
                <div className="col-6"></div>
                <div className="col-3">
                {checkIds.length>0&&<><button id="approve-btn" onClick={() => { handleSave("approved") }
                         } style={{ backgroundColor:"green",width:"46%" }} className="clinic_button">Approve</button>
                     &nbsp;&nbsp;
                    <button id="reject-btn" onClick={() => { handleSave("rejected") }
                         } style={{ backgroundColor:"red",width:"46%" }} className="clinic_button">Reject</button></>}
                     
                </div>
                
                </h6>
                <div className="row " style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left",padding:"1%", borderRadius:"5px 5px 0px 0px"}}>
                    <div  className="col-3"></div>
                    <div className="col-2"><b >Requested</b></div>   
                    <div className="col-3"><b >Date</b></div>                   
                    <div className="col-3"><b >Payable amount</b></div>
                    <div className="col-1"><b >
                    { license.requested_licenses.length===checkIds.length?
                    <svg onClick={(e) => {setCheckIds([])}}xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m9 11l3 3l8-8"/><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9"/></g></svg>
                    : <svg onClick={(e) => {
                        license.requested_licenses&&license.requested_licenses.map((item)=>{ setCheckIds((prevItems) =>prevItems.includes(item.purchased_id) ? prevItems : [...prevItems, item.purchased_id]);})
                    } }
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z"/></svg>}
                        
                    </b></div>
                    
                </div>
                
                {license.requested_licenses&&license.requested_licenses.map((item)=>{
                    return(<div className="row " style={{ textAlign: "left",borderLeft:"0.4px solid gray", borderBottom:"0.4px solid gray",borderRight:"0.4px solid gray"}}>
                        <div style={{backgroundColor:"#BFC7DA", padding:"1%",borderRight:"0.4px solid gray"}}className="col-3">{item.license_name}</div>
                        <div style={{ padding:"1%"}} className="col-2">{item.requested}</div> 
                    <div style={{ padding:"1%"}} className="col-3">
                      {item.requested_date.slice(0,10)}
                      </div>                                       
                    <div style={{ padding:"1%"}}className="col-3">RS {item.total_license_amount}/-</div>
                    <div style={{ padding:"1%"}}className="col-1" >
                    {checkIds.includes(item.purchased_id)?<svg onClick={(e) => {setCheckIds((prevItems) => prevItems.filter((i) => i !== item.purchased_id));}}xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="m9 11l3 3l8-8"/><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h9"/></g></svg>:
                <svg onClick={(e) => {setCheckIds((prevItems) => [...prevItems, item.purchased_id])}}xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19 3H5c-1.11 0-2 .89-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 2v14H5V5z"/></svg>}
                        </div></div>
                    )
                })}
                    
                    

                   
            </div><br/></>}
      <div className="" style={{}}>
                <h6 className="row"><b className="col-3">{license.version}(<b style={{color:"green"}}>{license.plan_type&&license.plan_type.replace(/_/g, ' ')}</b>)</b>
                
               {license.plan_type==="full_time"?<><span className="col-8"><small style={{color:"green"}}>Plan start date: <b>{license.start_date&&license.start_date.slice(0,10)}</b></small> &nbsp;&nbsp;
               {license.amc_start_date&&
               <small> AMC start date: <b>{license.amc_start_date.slice(0,10)}</b></small>}&nbsp;&nbsp;&nbsp;
               <small style={{color:"orange"}} >Support period:  <b> {license.support_period} days</b></small></span></>:<> <span className="col-6"><small style={{color:"green"}}>License Validity Period: <b>{license.start_date&&license.start_date.slice(0,10)} to {license.end_date&&license.end_date.slice(0,10)}</b></small>
                <small style={{color:"orange"}} > ( <b>Free for {license.free_period} days</b>)</small></span></>}
                {/* <span className="col-1" ></span> */}
                </h6>
                <div className="row " style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left",padding:"1%", borderRadius:"5px 5px 0px 0px"}}>
                    <div  className="col-3"></div>
                    <div className="col-2"><b >Free users</b></div>
                    <div className="col-2"><b >Paid users </b></div>
                   
                    <div className="col-3"><b >Price</b></div>
                    <div className="col-2"><b >Unused</b></div>
                    
                    
                </div>
                
                {license.licenses&&license.licenses.map((item)=>{
                    return(<div className="row " style={{ textAlign: "left",borderLeft:"0.4px solid gray", borderBottom:"0.4px solid gray",borderRight:"0.4px solid gray",}}>
                        <div style={{backgroundColor:"#BFC7DA", padding:"1%",borderRight:"0.4px solid gray"}}className="col-3">{item.license_name}</div>
                    <div style={{ padding:"1%"}} className="col-2">{item.free_users}</div>
                    <div style={{ padding:"1%"}}className="col-2">{item.paid_users}</div>
                    
                    <div style={{ padding:"1%"}}className="col-3">RS {item.extra_user_price*item.paid_users}/-</div>
                    <div style={{ padding:"1%"}} className="col-2" >{item.unused}</div></div>
                    )
                })}
                    
                    

                   
            </div><br/>
           </>:
            <div
            style={{
              color: "red",
              fontSize: "25px",
              height: "200px",
              padding: "10%",
            }}
          >
            <h4>No Licenses Associated!!</h4>
          </div>}
        </div>
  );
}
export default LicenseDetails;
